/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateScanResultResponse {
    getFixupPrototypeFunction() { return TemplateScanResultResponse.fixupPrototype; }

    static newInstance(model: Partial<TemplateScanResultResponse>): TemplateScanResultResponse {
        let obj = Object.assign(new TemplateScanResultResponse(), model);
        TemplateScanResultResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateScanResultResponse>): TemplateScanResultResponse {
        if (!model) return null;
        return TemplateScanResultResponse.newInstance(<TemplateScanResultResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateScanResultResponse) {
        if (!obj) return;

        models.TemplateScanResultResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateScanResultResponse): boolean {
        Object.setPrototypeOf(obj, TemplateScanResultResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.summary) {
            models.TemplateScanSummary.fixupPrototype(this.summary);
        }
        if (this.params) {
            for (let val of this.params) {
                models.NamedParameter.fixupPrototype(val);
            }
        }
        if (this.results) {
            for (let val of this.results) {
                models.TemplateScanCheckResult.fixupPrototype(val);
            }
        }
    }

    /**
     * Scan status: 'in_progress' while running, 'error' on failure, 'completed' when finished
     */
    status: models.TemplateScanStatus;

    /**
     * Error details. Present only when status=ERROR
     */
    status_message: string;

    /**
     * All resource types found in the template content
     */
    total_resources: Array<string>;

    /**
     * Resource types with at least one applicable check
     */
    valid_resources: Array<string>;

    /**
     * Check names applicable to this template's resources
     */
    valid_checks: Array<string>;

    /**
     * The parameter values used for this scan
     */
    params: Array<models.NamedParameter>;

    /**
     * Pass/fail counts, present once the scan completes
     */
    summary: models.TemplateScanSummary;

    /**
     * Individual check results, present once the scan completes
     */
    results: Array<models.TemplateScanCheckResult>;

}
